export enum Types {
	CONSULTAR_CIDADAO_AUTISTA_REQUEST = '@iirgd/CONSULTAR_CIDADAO_AUTISTA_REQUEST',
	CONSULTAR_CIDADAO_AUTISTA_SUCCESS = '@iirgd/CONSULTAR_CIDADAO_AUTISTA_SUCCESS',
	CONSULTAR_CIDADAO_AUTISTA_FAILURE = '@iirgd/CONSULTAR_CIDADAO_AUTISTA_FAILURE',
	CONSULTAR_CIDADAO_AUTISTA_CLEAR = '@iirgd/CONSULTAR_CIDADAO_AUTISTA_CLEAR',
}

export interface ConsultarCidadaoAutista {
	data: ConsultarCidadaoAutistaData | null;
	status: number;
}

export interface ConsultarCidadaoAutistaRequest {
	header: {
		usuario: string;
		senha: string;
	};
	query: {
		numeroRg: string;
		digitoRg: string;
	};
}

export interface ConsultarCidadaoAutistaData {
	numeroRg: string;
	digitoRg: string;
	nome: string;
	dataNascimento: string;
	ciptea: boolean;
	dataValidade: string;
	responsavel: {
		cpf: string;
		nome: string;
		logradouro: string;
		logradouroNumero: string;
		logradouroComplemento: string;
		logradouroBairro: string;
		logradouroCEP: string;
		logradouroMunicipioCodigo: string;
		logradouroMunicipioDigito: string;
		emailUsuario: string;
		emailDominio: string;
		telefoneDDD: string;
		telefoneNumero: string;
	};
}
